import React from "react";
import BaseReactTooltip from "react-tooltip";
import styled from "styled-components";
import { colors, InfoIcon } from "@commonsku/styles";

import { useTooltipAttributes } from "../hooks";

type TooltipPlacement = "top" | "left" | "right" | "bottom";
type TooltipEffect = "float" | "solid";

const TOOLTIP_BG = colors.neutrals.darkest;

interface StyledTooltipProps {
  maxWidth?: string | number;
}

const StyledTooltip = styled(BaseReactTooltip)<StyledTooltipProps>`
  background-color: ${TOOLTIP_BG} !important;
  color: #fff !important;
  padding: 8px 12px !important;
  opacity: 1 !important;
  ${props => props.maxWidth ? `max-width: ${typeof props.maxWidth === 'number' ? `${props.maxWidth}px` : props.maxWidth} !important;` : ''}

  &.place-top:after {
    border-top-color: ${TOOLTIP_BG} !important;
    background-color: ${TOOLTIP_BG} !important;
  }
  &.place-bottom:after {
    border-bottom-color: ${TOOLTIP_BG} !important;
    background-color: ${TOOLTIP_BG} !important;
  }
  &.place-left:after {
    border-left-color: ${TOOLTIP_BG} !important;
    background-color: ${TOOLTIP_BG} !important;
  }
  &.place-right:after {
    border-right-color: ${TOOLTIP_BG} !important;
    background-color: ${TOOLTIP_BG} !important;
  }
`;


export interface InfoTooltipProps {
  tooltipId: string;
  tooltipContent: React.ReactNode;
  ariaLabel: string;
  size?: number;
  color?: string;
  place?: TooltipPlacement;
  effect?: TooltipEffect;
  className?: string;
  style?: React.CSSProperties;
  tabIndex?: number;
  maxWidth?: string | number;
  icon?: React.ComponentType<{ size?: string }>;
}

export const InfoTooltip = ({
  tooltipId,
  tooltipContent,
  ariaLabel,
  size = 22,
  color = colors.primary2,
  place = "top",
  effect = "solid",
  className,
  style,
  tabIndex = 0,
  maxWidth,
  icon: Icon = InfoIcon,
}: InfoTooltipProps) => {
  const tooltipAttributes = useTooltipAttributes(tooltipContent, tooltipId, {
    place,
    effect,
  });

  return (
    <>
      <span
        aria-label={ariaLabel}
        role="img"
        tabIndex={tabIndex}
        className={className}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: size,
          height: size,
          cursor: "help",
          color,
          lineHeight: 0,
          ...style,
        }}
        {...(tooltipAttributes ?? {})}
      >
        <Icon size='small' />
      </span>
      <StyledTooltip id={tooltipId} effect={effect} maxWidth={maxWidth} />
    </>
  );
};
